module.exports = require("ramda/src/endsWith");